// TODO These were copied directly into the mbs app so we can remove this
export const GLOBAL_PARAMS = [
    "/mbsh-app/env/PORT",
    "/mbsh-app/env/GOOGLE_PLACES_API_KEY",
    "/mbsh-app/env/LOCAL_BUILD",
    "/mbsh-app/env/ASP_CIPHER_KEY",
    "/mbsh-app/env/ASP_CIPHER_IV",
    "/mbsh-app/env/TRANSITION_API_ENDPOINT",
    "/mbsh-app/env/TRANSITION_API_KEY",
    "/mbsh-app/env/NODE_ENV",
    "/mbsh-app/env/SESSION_SECRET",
    "/mbsh-app/env/STLOUISFED_API",
    "/mbsh-app/env/MANDRILL_API_KEY",
    "/mbsh-app/env/MBS_WEB_SERVER_ENDPOINT",
    "/mbsh-app/env/DEMO_USER_ID",
    "/mbsh-app/env/DEMO_SCENARIO_ID",
    "/mbsh-app/env/GRINDER_ENDPOINT",
    "/mbsh-app/env/ZOOM_VIDEO_SDK_KEY",
    "/mbsh-app/env/ZOOM_VIDEO_SDK_SECRET",
    "/mbsh-app/env/AWS_S3_BUCKET",
    "/mbsh-app/env/AWS_CLOUDFRONT_BASE",
    "/mbsh-app/env/GRINDER_API_KEY",
    "/mbsh-app/env/OPTIMAL_BLUE_SECRET",
    "/mbsh-app/env/OPTIMAL_BLUE_CLIENT_ID",
    "/mbsh-app/env/LAUNCH_DARKLY_KEY",
    "/mbsh-app/env/MONGO_CONNECTION_STRING",
    "/mbsh-app/env/LISTING_BOOSTER_API_KEY",
    "/mbsh-app/env/MIXPANEL_TOKEN",
    "/mbsh-app/env/MBS_API_ENDPOINT",
    "/mbsh-app/env/MBS_API_KEY",
    "/mbsh-app/env/LR_API_ENDPOINT",
    "/mbsh-app/env/LR_API_KEY",
    "/mbsh-app/env/BRAZE_API_KEY",
    "/mbsh-app/env/BRAZE_URL",
];
